import i18n from '../../../lang/index'
export const rules = {
    // alarmType: [
    //     { required: true, message: i18n.t('faultList.inputFaultType'), trigger: 'blur' },
    // ],
    relatedItems: [
        { required: true, message: i18n.t('faultList.pleChoReProduct'), trigger: 'change' },
    ],
    alarmCode: [
        { required: true, message: '请输入两位十六进制的故障编码', trigger: 'blur' },
    ]
}